import { useState, useEffect } from 'react';
import { UserSearchForm } from '../types';

type UseUserSearchProps = {
  initialForm?: UserSearchForm;
};

export const useUserSearch = (props?: UseUserSearchProps) => {
  const [formData, setFormData] = useState<UserSearchForm>({
    name: props?.initialForm?.name || '',
    email: props?.initialForm?.email || '',
    startDate: props?.initialForm?.startDate || '',
    endDate: props?.initialForm?.endDate || ''
  });

  const [error, setError] = useState<string | null>(null);

  // 初期値が変更された場合にフォームを更新
  useEffect(() => {
    if (props?.initialForm) {
      setFormData(props.initialForm);
    }
  }, [props?.initialForm]);

  const handleFieldChange = (field: keyof UserSearchForm, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    // フィールド変更時にエラーをクリア
    if (error) {
      setError(null);
    }
  };

  const resetSearch = () => {
    setFormData({
      name: '',
      email: '',
      startDate: '',
      endDate: ''
    });
    setError(null);
  };

  return {
    formData,
    error,
    handleFieldChange,
    resetSearch,
    setError
  };
};
